import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCategories } from '../../services/api';

const defaultCategories = [
  {
    id: 'necklace',
    name: 'Necklace',
    image: 'https://images.unsplash.com/photo-1611078482615-cb8f2c9e6b8c?w=400',
  },
  {
    id: 'ring',
    name: 'Ring',
    image: 'https://images.unsplash.com/photo-1611599536961-ec19cdb6c29b?w=400',
  },
  {
    id: 'bracelet',
    name: 'Bracelet',
    image: 'https://images.unsplash.com/photo-1600180758895-1ce3ecfd5bfc?w=400',
  },
  {
    id: 'earrings',
    name: 'Earrings',
    image: 'https://images.unsplash.com/photo-1598514982837-4f4d7e2fa218?w=400',
  },
  {
    id: 'pendant',
    name: 'Pendant',
    image: 'https://images.unsplash.com/photo-1603791440384-56cd371ee9e7?w=400',
  },
  {
    id: 'watch',
    name: 'Watch',
    image: 'https://images.unsplash.com/photo-1600180758930-3072c5e6a9d0?w=400',
  },
];

const CategoryGrid = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategories();
        if (response.data && response.data.length > 0) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const displayCategories = categories.length > 0
    ? categories.map((cat) => ({
        id: cat._id,
        name: cat.CategoryName,
        image: cat.image,
      }))
    : defaultCategories;

  return (
    <Box sx={{ py: 6, bgcolor: '#fff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant="overline"
            sx={{ color: '#876513', fontWeight: 600, letterSpacing: 2 }}
          >
            Browse By
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, color: '#3E2723', mt: 1 }}
          >
            Shop by Category
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          {displayCategories.slice(0, 6).map((category) => (
            <Grid item xs={6} sm={4} md={2} key={category.id}>
              <Paper
                onClick={() => navigate(`/filter/${category.id}`)}
                elevation={0}
                sx={{
                  cursor: 'pointer',
                  textAlign: 'center',
                  p: 2,
                  borderRadius: 3,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: { xs: 80, md: 100 },
                    height: { xs: 80, md: 100 },
                    borderRadius: '50%',
                    overflow: 'hidden',
                    mx: 'auto',
                    mb: 2,
                    border: '3px solid #f5ebe0',
                  }}
                >
                  <img
                    src={category.image}
                    alt={category.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: '#3E2723' }}
                >
                  {category.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CategoryGrid;
